import PillButton from 'components/buttons/PillButton';
import PropTypes from 'prop-types';

const NightPill = ({ children, onClick, selected }) => {
  return (
    <PillButton onClick={onClick} selected={selected} showX={false} blackFont>
      {children}
    </PillButton>
  );
};

NightPill.propTypes = {
  children: PropTypes.string,
  onClick: PropTypes.func,
  selected: PropTypes.bool,
};

export default NightPill;
